import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import logo from '../assets/logo-removebg.png';
import welcomeImage from '../assets/OK1.gif'; // Add the path to your welcome image here
import henry from '../assets/henry.jpg'; //
import evelyne from '../assets/evelyne.jpeg'; //
import Samwel from '../assets/samwel.jpeg'; //import evelyne from '../assets/evelyne.jpeg'; //
import Xolisile from '../assets/xolisile.jpeg'; //


// Team member data
const teamMembers = [
  {
    id: 1,
    name: 'Henry Mwiki',
    position: 'Founder/Chairman',
    image: henry ,// Replace with actual image path
    country: '',
    role:'Cybersecurity Expert ',
    education: 'BSc, MSc, MBA, PhD (C)'
  },
  {
    id: 2,
    name: 'Evelyine Fabian',
    position: 'Judge/Advisor',
    image: evelyne,
    country: 'United Kingdom (UK)',
    role:'Information Security and Data Privacy Expert',
    education: 'LL.B, 2* MSc'
  },
  {
    id: 3,
    name: 'Samwel Mbawala',
    position: 'Judge/Advisor',
    image: Samwel,
    country: 'Tanzania',
    role:'Senior Lecturer & Advocate',
    education: 'LL.B, LL.M, PhD (C)'
  },
  {
    id: 4,
    name: 'Xolisile Thusini',
    position: 'Judge/Advisor',
    image: Xolisile,
    country: 'South Africa',
    role:'Artificial Intelligence Expert',
    education: 'BS.,2* MSc, PhD (C)'
  }
];

// Styled Components
const TeamSection = styled.section`
  padding: 50px 20px;
  background-color: #000; /* Black background */
  color: #fff; /* Light text color */
  text-align: center;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
`;

const MemberCard = styled.div`
  background: #1a1a1a; /* Dark gray card background */
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 6px 15px rgba(255, 255, 255, 0.1);
  }
`;

const MemberImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
  border: 3px solid #fff; /* White border around image */
`;

const MemberName = styled.h3`
  margin: 10px 0 5px;
  font-size: 1.2rem;
  color: #ffffff;
`;

const MemberPosition = styled.p`
  color: #cccccc;
  font-size: 0.95rem;
`;




const HeroContainer = styled.div`
  display: flex;
  // justify-content: space-between;
  justify-content: center;
  align-items: center;
  // height: 100vh; /* Full viewport height */
  // height: calc(100vh - 30px); /* Adjust for the height of the header */
  background-color: ${({ theme }) => theme.colors.backgroud};
  color: ${({ theme }) => theme.colors.primary};
  padding: 0 20px;
  // padding-bottom: 100px;
  height:100vh;
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  // padding-top: 100px;
  
  @media (max-width: 768px) { /* when viewed on mobileS */
  flex-direction: column;
  justify-content: space-around;

     }
`;

const HeroText = styled.div`
  margin-bottom: 20px;
`;

const HeroTitle = styled.h1`
  font-size: 3em;
`;

const HeroSubtitle = styled.h3`
  font-size: 1.5em;
`;

const HeroBlink = styled.div`
  color: #ff5722; 
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 18px;
  animation: blink-animation 1.8s linear infinite;
  @keyframes blink-animation {
  0%, 50%, 100% { opacity: 1; }
  25%, 75% { opacity: 0; }
}

`;

const HeroButton = styled.button`
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.secondary};
  padding: 10px 20px;
  font-size: 1.2em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.primary};
    transform: scale(1.08);
    };
    
`;

const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
  // padding-top: 50px;

`;

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const WelcomeImageContainer = styled.div`
  width: 100%;
  max-width: 50%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const WelcomeImage = styled.img`
  width: 100%;
  height: auto;
`;

const WelcomeTextContainer = styled.div`
  width: 100%;
  max-width: 50%;
  padding: 20px;
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;
  }
`;

const CountdownContainer = styled.div`
  text-align: center;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.primary};
  margin: 20px 0;
  border-top: 5px solid ${({ theme }) => theme.colors.primary}; /* Top border */
  border-bottom: 5px solid ${({ theme }) => theme.colors.primary}; /* Bottom border */
  border-radius: 5px;
  font-family: 'Maven Pro', sans-serif; /* Apply digital-style font */
`;

const CountdownText = styled.h2`
  text-transform: uppercase;
  margin-bottom: 20px;
  font-size: 1.5em;
  letter-spacing: 0.1em;
`;

const CountdownTimer = styled.div`
  font-size: 2.5em;
  font-family: 'Maven Pro', sans-serif; /* Apply digital-style font */
  letter-spacing: 0.1em;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 30px; /* Space between time parts */
   
  @media (max-width: 768px) {/*on mobile views */
    max-width: 100%;
    font-size: 1.5em;
    gap:20px;
  }
`;

const CountdownLabels = styled.div`
  font-size: 1em;
  display: flex;
  justify-content: center;
  gap: 50px; /* Space between labels, matching the time parts */
  text-transform: uppercase;
  @media (max-width: 768px) {/*on mobile views */
    max-width: 100%;
    font-size: 1.0em;
    gap:15px;
  }
`;

const CountdownLabelItem = styled.span`
  text-align: center;
  font-weight: bold;
`;


const AwardsContainer = styled.div`
  padding: 20px;
`;

const AwardsTitle = styled.h2`
  font-size: 2em;
  margin-bottom: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`;

const CategoryContainer = styled.div`
  margin-bottom: 20px;
`;

const CategoryTitle = styled.h3`
  font-size: 1.5em;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.primary};
`;

const AwardList = styled.ul`
  list-style: none;
  padding: 0;
`;

const AwardItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 10px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

const AwardDescription = styled.p`
  margin: 10px 0;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
`;

const awardsData = {
  Individuals: [
    "Cybersecurity Woman of the Year",
    "Cybersecurity Ethical Hacker of the Year",
    "Cybersecurity Auditor of the Year",
    "Cybersecurity SOC of the year",
    "Cybersecurity GRC of the year",
    "Cybersecurity Personality of the Year",
    "Cybersecurity Rising Star of the Year",
    "Cybersecurity Influencer of the Year",
    "Cybersecurity Entrepreneur of the Year",
    "Cybersecurity Consultant of the Year",
    "CISO of the year",
    "Cybersecurity Researcher of the Year",
    "Cybersecurity Innovator of the Year"
  ],
  Business: [
    "Cybersecurity Start-up of the year",
    "Cybersecurity Service Provider of the Year",
    "Cybersecurity Vendor of the Year"
  ],
  Industry: [
    "Cybersecurity Leader in Banking",
    "Cybersecurity Leader in Telecom",
    "Cybersecurity Leader in the Government and Public sector",
    "Cybersecurity Leader in Healthcare",
    "Cybersecurity Leader in Education"
  ],
  EducationAndLearning: [
    "Cybersecurity School of the year",
    "Cybersecurity University of the year",
    "Cybersecurity Student of the year",
    "Cybersecurity Instructor of the Year",
    "Cybersecurity Lecturer of the Year"
  ],
  Community: [
    "Cybersecurity Citizen of the Year",
    "Cybersecurity Police of the Year"
  ],
  PrestigeAward: [
    "Cybersecurity Prestige award of the year",
    "Cybersecurity Lifetime Achievement Award"
  ]
};

const Home = () => {
  const [expandedAward, setExpandedAward] = useState(null);
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  function calculateTimeLeft() {
    const targetDate = new Date('DECEMBER 02, 2024 00:00:00').getTime();
    const now = new Date().getTime();
    const difference = targetDate - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  const toggleAward = (award) => {
    setExpandedAward(expandedAward === award ? null : award);
  };
  // const handleClick = () => {
  //   window.open("https://forms.gle/zsoUgbhDAJJx68gn8", "_blank")
  // }
  
  return(
  <>
  <HeroContainer>
    <HeroContent>
    <LogoImage src={logo} alt="Africa Cybersecurity Awards Logo" />
      <HeroText>
        <HeroTitle>Africa Cybersecurity Awards (ACA)</HeroTitle>
        <HeroSubtitle>Honoring Innovation and Excellence in Cybersecurity Across Africa</HeroSubtitle>
      </HeroText>
      {/* <HeroBlink>Nominations are Open!</HeroBlink> */}
      {/* <HeroButton onClick={handleClick}>Celebrate Excellence, Nominate Now!</HeroButton> */}
    </HeroContent>
    
  </HeroContainer>

  <WelcomeContainer>
      <WelcomeImageContainer>
        <WelcomeImage src={welcomeImage} alt="Welcome" />
      </WelcomeImageContainer>
      <WelcomeTextContainer>
        <h2>Welcome to the inaugural Africa Cybersecurity Awards</h2>
        <p>
        The first of their kind on the continent, dedicated exclusively to recognizing excellence in cybersecurity. Here, we celebrate and honor the exceptional individuals, teams, and organizations who are at the forefront of securing Africa's digital future. As our continent continues to embrace the transformative power of technology, the need for robust cybersecurity has never been more critical. These awards shine a spotlight on the innovators, protectors, and pioneers leading the charge in safeguarding our digital landscape. Join us as we recognize the champions of cybersecurity who are not only defending but also empowering Africa's digital growth and resilience.
        </p>
      </WelcomeTextContainer>
    </WelcomeContainer>
     {/* Countdown Section */}
     <CountdownContainer>
      <CountdownText>Get ready nominations for 2025 are just around the corner!</CountdownText>
        {/* <CountdownTimer>
          <span>{timeLeft.days}</span>:<span>{timeLeft.hours}</span>:<span>{timeLeft.minutes}</span>:<span>{timeLeft.seconds}</span>
        </CountdownTimer>
    <CountdownLabels>
      <CountdownLabelItem>Day(s)</CountdownLabelItem>
      <CountdownLabelItem>Hours</CountdownLabelItem>
      <CountdownLabelItem>Minutes</CountdownLabelItem>
      <CountdownLabelItem>Seconds</CountdownLabelItem>
    </CountdownLabels> */}
  </CountdownContainer>

    <AwardsContainer>
        <AwardsTitle>Categories</AwardsTitle>
        {Object.keys(awardsData).map((category) => (
          <CategoryContainer key={category}>
            <CategoryTitle>{category.replace(/([A-Z])/g, ' $1').trim()}</CategoryTitle>
            <AwardList>
              {awardsData[category].map((award, index) => (
                <div key={index}>
                  <AwardItem onClick={() => toggleAward(award)}>
                    {award}
                    <span>{expandedAward === award ? '-' : '+'}</span>
                  </AwardItem>
                  {expandedAward === award && (
                    <AwardDescription>
                      The {award} ......
                    </AwardDescription>
                  )}
                </div>
              ))}
            </AwardList>
          </CategoryContainer>
        ))}
      </AwardsContainer>
          <TeamSection>
      <h2>Our Team</h2>
      <TeamGrid>
        {teamMembers.map(member => (
          <MemberCard key={member.id}>
            <MemberImage src={member.image} alt={member.name} />
            <MemberName>{member.name}</MemberName>
            <MemberPosition>{member.position}</MemberPosition>
            <MemberPosition>{member.role}</MemberPosition>
            <MemberPosition>{member.education}</MemberPosition>
            <MemberPosition>{member.country}</MemberPosition>
          </MemberCard>
        ))}
      </TeamGrid>
    </TeamSection>
    


  </>
  )
};

export default Home;
